import { AssetTagBadge } from '@/app/assets/details/atoms/AssetTagBadge';
import { useTagsSuggestion } from '@/app/assets/details/hooks/useTagsSuggestion';
import { Autocomplete, Text, Group } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useEffect, useRef, useState } from 'react';
import CloseIcon from '@/icons/close.svg';
import { IconPlus } from '@tabler/icons-react';

/* THIS COMPONENT IS USED IN MULTIPLE PLACES */
/* AS OF THIS COMMIT IN 3 PLACES :) */
/* MAKE SURE YOU DIDN'T BREAK THE OTHER USAGES */

export const NewTag = ({ onAddTag, tags }: { onAddTag: (tag: string) => void; tags?: string[] }) => {
  const [opened, { open, close }] = useDisclosure(false);
  const suggestions = useTagsSuggestion(tags);
  const [newTag, setNewTag] = useState('');
  const tagInputRef = useRef<HTMLInputElement>(null);

  const onAddSubmit = () => {
    if (!newTag) {
      return close();
    }
    onAddTag(newTag);
    setNewTag('');
    close();
  };

  useEffect(() => {
    if (opened) {
      tagInputRef.current?.focus();
    }
  }, [opened, tagInputRef]);

  if (opened) {
    return (
      <Group gap='xs'>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onAddSubmit();
          }}
        >
          <Autocomplete
            placeholder='input tag and press enter..'
            ref={tagInputRef}
            value={newTag}
            onChange={(value) => setNewTag(value)}
            data={newTag ? suggestions : undefined}
            onBlur={onAddSubmit}
            w={180}
          />
        </form>
        <CloseIcon onClick={close} style={{ cursor: 'pointer' }} />
      </Group>
    );
  }
  return (
    <AssetTagBadge
      icon={
        <Text fw={700} pr={4}>
          <IconPlus width={16} />
        </Text>
      }
      badgeClick={open}
    />
  );
};
